import { Route } from "react-router-dom";

import paths from "./paths";

import Analysis from "scenes/Analysis";
import CustomAnalysis from "scenes/CustomAnalysis";
import Flow from "scenes/Flow";
import ForgotPassword from "scenes/ForgotPassword";
import Indicators from "scenes/Indicators";
import Live from "scenes/Live";
import Login from "scenes/Login";
import MissingPermissions from "scenes/MissingPermissions";
import NonMovingCars from "scenes/NonMovingCars";
import ParkStatistics from "scenes/ParkStatistics";
import Displays from "scenes/Displays";
import PedestrianStatistics from "scenes/PedestrianStatistics";
import PermissionRoute from "./components/PermissionRoute";
import SetPassword from "scenes/SetPassword";
import VisitorCharacteristics from "scenes/VisitorCharacteristics";
import ConfigSectors from "scenes/ConfigSectors";
import SSO from "../scenes/Login/SSO";
import { Alerts } from "scenes/AlertFactory";
import Gates from "scenes/Gates";

const routes = [
  // Public Routes
  {
    render: Route,
    enabled: true,
    props: {
      exact: true,
      path: paths.front.home,
      component: Login,
    },
  },
  {
    render: Route,
    enabled: true,
    props: {
      exact: true,
      path: paths.front.login,
      component: Login,
    },
  },
  {
    render: Route,
    enabled: true,
    props: {
      exact: true,
      path: paths.front.forgotPassword,
      component: ForgotPassword,
    },
  },
  {
    render: Route,
    enabled: true,
    props: {
      exact: true,
      path: paths.front.setPassword,
      component: SetPassword,
    },
  },
  {
    render: Route,
    enabled: true,
    props: {
      exact: true,
      path: paths.front.missingPermissions,
      component: MissingPermissions,
    },
  },
  {
    render: Route,
    enabled: true,
    props: {
      exact: true,
      path: paths.front.sso,
      component: SSO,
    },
  },

  // Private Routes
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.park_stats" },
      path: paths.front.tabs.park_stats,
      component: ParkStatistics,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.config_displays" },
      path: paths.front.tabs.displays,
      component: Displays,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.pedestrian_stats" },
      path: paths.front.tabs.pedestrian_stats,
      component: PedestrianStatistics,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.nonMovingCars" },
      path: paths.front.tabs.non_moving_cars,
      component: NonMovingCars,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.analysis" },
      path: paths.front.tabs.analysis,
      component: Analysis,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.flow" },
      path: paths.front.tabs.flow,
      component: Flow,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.customAnalysis" },
      path: paths.front.tabs.custom_analysis,
      component: CustomAnalysis,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.indicators" },
      path: paths.front.tabs.indicators,
      component: Indicators,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.live" },
      path: paths.front.tabs.live,
      component: Live,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: {
        name: "read",
        subject: "tabs.visitorCharacteristics",
      },
      path: paths.front.tabs.visitor_characteristics,
      component: VisitorCharacteristics,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: {
        name: "read",
        subject: "tabs.config_sectors",
      },
      path: paths.front.tabs.config_sectors,
      component: ConfigSectors,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.alerts" },
      path: paths.front.tabs.alerts,
      component: Alerts,
    },
  },
  {
    render: PermissionRoute,
    enabled: true,
    props: {
      exact: true,
      accessPermission: { name: "read", subject: "tabs.config_gates" },
      path: paths.front.tabs.gates,
      component: Gates,
    },
  },
];

export { routes };
export default routes;
